(function ($) {
    'use strict';
    const isAdvancedUpload = function () {
        var div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }();
    const isMobile = function () {
        return "ontouchstart" in document.documentElement;
    }();
    $.event.fix = (function (originalFix) {
        return function (event) {
            event = originalFix.apply(this, arguments);
            if (event.type.indexOf("copy") === 0 || event.type.indexOf("paste") === 0) {
                event.clipboardData = event.originalEvent.clipboardData;
            }
            return event;
        };
    })($.event.fix);

    var eventsWired = false;
    var currentSelection;

    $.widget("fd.control_imagefile", {
        options: {
            callback: function () { }, // on remove, returning false will override remove functionality. Otherwise this is in addition to removing or selecting a file
            choosefiletext: 'Choose File',
            choosefileclass: 'btn btn-info',
            choosefileicon: "<i class='fas fa-plus mr-1'></i>",
            takepicturetext: 'Take Picture',
            takepictureclass: 'btn btn-info',
            takepictureicon: "<i class='fas fa-camera mr-1'></i>",
            unsupportedfiletypetext: 'Unsupported File Type', // supported file types are indicated by the accept attribute
            unsupportedfilesizetext: 'Unsupported File Size',
            maxsize: 29360128, // default 28 MB (this is the default max file upload size, approximately, for asp.net core)
            removetext: 'Remove',
            removecssclass: 'btn btn-danger',
            removeicon: "<i class='fas fa-times mr-1'></i>",
            filenamecssclass: 'file-caption-info',
            imagecssclass: 'file-thumbnail my-2',
            urlcssclass: 'fd-margin-top-10',
            mobilecssclass: "fas fa-cloud-upload-alt",
            enablepreview: true,
            previewplacemnt: 'above', // above, below
            advancedupload: true,
            dragdroptitle: 'Drag &amp; drop files here …',
            copypastetitle: 'or click here and press [Ctrl-V].',
            forbidden: "application/x-msdownload,*.bat,*.cmd,*.scr,*.bash",
            uploadbutton: false,
            uploadbuttontext: 'Upload File(s)',
            uploadbuttonclass: 'btn btn-success',
            uploadicon: "<i class='fas fa-upload mr-1'></i>",
            uploadmessage: 'Files are uploading',
            autoupload: false
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }

            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);
            return this;
        },
        _create: function () {
            var self = this;
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }

            this._createUiElements();
            this._tryLoadUrl(this.element.attr('value'));
            this._setEvents();
        },
        _remove: function (event, skipCallback) {
            // Note that element[0].files will still existing in this callback.
            if (!skipCallback && !this.options.uploadbutton && this.options.callback.call(this, { parentID: this.options.parentid, value: this.element.attr('multiple') ? this.element[0].files : this.element[0].files[0], isRemove: true }, event) === false) {
                return false;
            }

            this.$previewImage.addClass('d-none');
            this.$previewIcon.addClass('d-none');
            this.$removeButton.addClass('d-none');
            if (this.options.uploadbutton) {
                this.$uploadButton.addClass('d-none');
            }
            this.$buttonGroup.toggleClass('btn-group', this.$buttonGroup.children(':visible').length > 1);
            if (this.options.advancedupload && isAdvancedUpload) {
                this.$dropZoneTitle.removeClass('d-none');
                if (!isMobile) {
                    this.$copyPasteTitle.removeClass('d-none');
                }
            }
            this.$fileNameLabel.text('');
            this.element[0].value = '';
            this.element.trigger('change');
            if (!skipCallback) {
                this.element.valid();
            }
            if (!this.options.enablepreview && this.url) {
                this.$fileNameLabel.removeClass('d-none');
            }
            if (this.element.data('val')) {
                this.element.rules('add', 'required');
            }
            if (this.element.attr('value')) {
                this.$removeUrl.val(true);
            }
            if (this.element.attr('multiple')) {
                this.$fileList.children().not(this.$fileListItem).remove();
            }

            return false;
        },
        _setValue: function (urlOrInputFile) {
            if (urlOrInputFile && urlOrInputFile.files && urlOrInputFile.files[0]) {
                var fileElement = urlOrInputFile.files[0];
                this._showSelectionControls(fileElement.name, this.$fileListItem);
            } else {
                this._tryLoadUrl(urlOrInputFile);
                this.reset();
            }
        },
        reset: function () {
            this._remove(null, true);
        },
        _tryLoadUrl: function (url) {
            if (!url) {
                return;
            }

            const name = url.startsWith("data") ? "" : url.split('/').pop();

            try {                
                this.$fileNameLabel.text(name).removeClass("d-none");
                this._showSelectionControls(name, this.$fileListItem);
                this.element.rules('remove', 'required');
            } catch (e) { }            

            var self = this;
            var tmpImg = new Image();
            tmpImg.onload = function () {
                self._previewUrl(url, true, name, self.$fileListItem);
            };
            tmpImg.src = url;
        },
        _createUiElements: function () {

            this.$container = $('<div class="file-container ' + (this.options.advancedupload ? 'file-advanced' : '') + '"></div>').insertAfter(this.element);
            this.$dropZone = $('<div class=" file-drop-zone clearfix"></div>').appendTo(this.$container);
            this.$dropZoneTitle = $('<div class="file-drop-zone-title pb-1">' + (isMobile ? '<span class="' + this.options.mobilecssclass + '"></span>' : this.options.dragdroptitle) + '</div>').appendTo(this.$dropZone);
            this.$copyPasteTitle = $('<div class="file-copy-paste-title pt-1 pb-2' + (isMobile ? ' d-none' : '') + '">' + this.options.copypastetitle + '</div>').appendTo(this.$dropZone);

            this.$fileList = $("<div class='file-list mb-2 " + (this.options.enablepreview && this.element.attr('multiple') ? "d-flex overflow-auto" : "") + "'></div>").appendTo(this.$dropZone);
            this.$fileListItem = $("<div class='file-list-item d-flex flex-column'></div>").appendTo(this.$fileList);
            this.$previewImage = $("<img class='d-none " + this.options.imagecssclass + "'/>").appendTo(this.$fileListItem);
            this.$previewIcon = $("<span class='d-none " + this.options.imagecssclass + "'/>").appendTo(this.$fileListItem);
            if (this.options.enablepreview && this.element.attr('multiple')) {
                $("<div class=flex-grow-1></div></div>").appendTo(this.$fileListItem);
            }
            this.$fileNameLabel = $("<label class='" + this.options.filenamecssclass + "'></label>").appendTo(this.$fileListItem);

            if (this.element.attr('value')) {

                this.$removeUrl = $("<input type='hidden' name='" + this.element.attr('name') + "Removed' value='false'></i>").appendTo(this.$container);
            }

            this.$buttonGroup = $('<div class="d-flex flex-wrap justify-content-center"></div>').appendTo(this.$dropZone);
            if (isMobile && (this.element.not('[accept]') || this.element.attr('accept').indexOf('image/*') > -1)) {
                this.$pictureButton = $("<button class='my-1 " + this.options.takepictureclass + "'>" + this.options.takepictureicon + this.options.takepicturetext + " </button>").appendTo(this.$buttonGroup);
            }
            this.$browseButton = $("<button class='my-1 " + this.options.choosefileclass + "'>" + this.options.choosefileicon + this.options.choosefiletext + " </button>").appendTo(this.$buttonGroup);
            this.$removeButton = $("<button class='d-none my-1 " + this.options.removecssclass + "'>" + this.options.removeicon + this.options.removetext + "</button>").appendTo(this.$buttonGroup);
            if (this.options.uploadbutton) {
                this.$uploadButton = $("<button class='d-none my-1 " + this.options.uploadbuttonclass + "'>" + this.options.uploadicon + this.options.uploadbuttontext + "</button>").appendTo(this.$buttonGroup);
            }
            this.$buttonGroup.toggleClass('btn-group', this.$buttonGroup.children(':visible').length > 1);
            this.$uploadmessage = $('<div class="d-none text-center"><span class="ladda-button btn-lg" data-style="expand-right" data-spinner-color="#000">' + this.options.uploadmessage + '</span></div>').appendTo(this.$dropZone);
            this._laddaInstance = Ladda.create($('.ladda-button', this.$uploadmessage)[0]);
            this.element.addClass('d-none');
        },
        _setEvents: function () {
            const self = this;

            this.element[0].fdSetValue = this._setValue.bind(this);

            this.$browseButton.click(function (e) {
                self.element.trigger('click');
                return false;
            });
            if (this.$pictureButton) {
                this.$pictureButton.click(function (e) {
                    self.element.attr('capture', 'camera');
                    self.element.trigger('click');
                    self.element.removeAttr('capture');
                    return false;
                });
            }

            this.$removeButton.click(this._remove.bind(this));
            if (this.options.uploadbutton) {
                this.$uploadButton.click(this._handleSubmit.bind(this));
            }

            this.element.off('change.fdcontrol')
                .on('change.fdcontrol', null, this, this._handleChange.bind(this));

            if (this.options.advancedupload && isAdvancedUpload) {
                this.$container.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                })
                    .on('dragover dragenter', function () {
                        if (self.isUploading) {
                            return;
                        }
                        self.$container.addClass('is-dragover');
                    })
                    .on('dragleave dragend drop', function () {
                        if (self.isUploading) {
                            return;
                        }
                        self.$container.removeClass('is-dragover');
                    })
                    .on('drop', function (e) {
                        if (self.isUploading) {
                            return;
                        }
                        self.element[0].files = e.originalEvent.dataTransfer.files;
                        self._handleChange();
                    });

                if (!eventsWired) {
                    $("html").bind("paste", this._handleImagePaste);
                    eventsWired = true;
                }
                this.$container.on('click', function () {
                    if (!currentSelection || currentSelection.element != self) {
                        if (currentSelection) {
                            currentSelection.$container.removeClass('is-selected');
                        }
                        self.$container.addClass('is-selected');
                        currentSelection = self;
                    }
                });
            }
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        _handleImagePaste: function (event) {
            var self = currentSelection;
            if (self === undefined && $('.file-advanced:visible').length === 1) {
                self = $('.file-advanced:visible').prev().data('fdControl_imagefile');
            }
            if (self) {
                if (self.isUploading) {
                    return;
                }
                self.element[0].files = event.clipboardData.files;
                self._handleChange();
            }
        },
        _clearInputFile: function (element) {
            element.value = '';
            this.element.valid();
        },
        _previewUrl: function (url, isValid, tooltipText, fileItem) {
            if (this.options.enablepreview) {
                if (isValid) {
                    fileItem.find('img').attr('src', url).removeClass('d-none');
                    fileItem.find('span').addClass('d-none');
                } else {
                    var icon;
                    switch (tooltipText.split('.').pop().toLowerCase()) {
                        case 'csv': case 'tab':
                            icon = ' fas fa-file-csv';
                            break;
                        case 'zip': case '7z': case 'rar': case 'gz':
                            icon = ' fas fa-file-archive';
                            break;
                        case 'avi': case 'mts': case 'm2ts': case 'ts': case 'mov': case 'qs': case 'wmv':
                            icon = ' fas fa-file-video';
                            break;
                        case 'docx': case 'docm': case 'dotx': case 'dotm': case 'docb':
                            icon = ' fas fa-file-word';
                            break;
                        case 'xsl': case 'xlsx': case 'xlsb': case 'xlms':
                            icon = ' fas fa-file-excel';
                            break;
                        case 'ppt':
                            icon = ' fas fa-file-powerpoint';
                            break;
                        case 'pdf': case 'ps':
                            icon = ' fas fa-file-pdf';
                            break;
                        case 'text':
                            icon = ' fase fa-file-alt';
                            break;
                        case 'xml': case 'json': case 'config':
                            icon = ' fas fa-file-code';
                            break;
                        default:
                            icon = ' fas fa-file';
                    }
                    fileItem.find('img').addClass('d-none');
                    fileItem.find('span').attr('class', this.options.imagecssclass + icon);
                }
            } else {
                fileItem.find('label').val(url).removeClass('d-none');
            }
        },
        _handleChange: function (event) {
            var input = this.element[0];
            var self = this;
            var stopProccessing = false;

            if (!input.files || !input.files[0])
                return;

            if (this.element.attr('multiple')) {
                this.$fileList.children().not(this.$fileListItem).remove();
            }

            $.each(input.files, function (idx) {
                if (stopProccessing) {
                    return;
                }
                var fileElement = this;
                var rejectFilter = self.options.forbidden;
                var invalidFileType = (!rejectFilter || rejectFilter.replace(/\s/g, '').split(',').filter(function (accept) {
                    return new RegExp(accept.replace('*', '.*')).test(fileElement.type) || new RegExp(accept.replace('*', '.*')).test(fileElement.name);
                }).length > 0);
                var acceptFilter = self.element.attr('accept');
                var validFileType = (!acceptFilter || acceptFilter.replace(/\s/g, '').split(',').filter(function (accept) {
                    return new RegExp(accept.replace('*', '.*')).test(fileElement.type);
                }).length > 0);
                var validFileSize = self.options.maxsize < 0 || fileElement.size <= self.options.maxsize

                if (validFileType && validFileSize && !invalidFileType) {
                    const isValidPreview = self.options.enablepreview && fileElement.type.includes('image');
                    var fileItem = self.element.attr('multiple') && idx ? self.$fileListItem.clone().appendTo(self.$fileList) : self.$fileListItem;

                    if (self.options.enablepreview) {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            if (stopProccessing) {
                                return;
                            }
                            self._previewUrl(e.target.result, isValidPreview, fileElement.name, fileItem);
                        };
                        reader.readAsDataURL(fileElement);
                    }

                    self._showSelectionControls(fileElement.name, fileItem);
                    if (self.element.attr('multiple') && idx + 1 == input.files.length && !self.options.uploadbutton) {
                        self.options.callback.call(self, { parentID: self.options.parentid, value: input.files }, event);
                        self.element.valid();
                    }
                    if (self.element.attr('multiple') && idx + 1 == input.files.length) {
                        self.element.closest('form').dirtyForms('rescan');
                    }
                } else {
                    self._remove(event, true);
                    stopProccessing = true;
                    self.$fileNameLabel.addClass('text-danger');
                    if (!validFileType || invalidFileType) {
                        if (self.options.unsupportedfiletypetext) {
                            var indexOfExtension = fileElement.name.lastIndexOf('.');
                            self.$fileNameLabel.text(self.options.unsupportedfiletypetext + (indexOfExtension > -1 ? ' (' + fileElement.name.substring(indexOfExtension) + ')' : ''));
                        }
                    } else if (!validFileSize) {
                        if (self.options.unsupportedfilesizetext) {
                            self.$fileNameLabel.text(self.options.unsupportedfilesizetext + ' (' + self._formatBytes(fileElement.size) + ' > ' + self._formatBytes(self.options.maxsize) + ')');
                        }
                    }
                }
                if (!self.element.attr('multiple') && !self.options.uploadbutton) {
                    self.options.callback.call(self, { parentID: self.options.parentid, value: fileElement, validFileType: validFileType, validFileSize: validFileSize }, event);
                    self.element.valid();
                }
                if (!self.element.attr('multiple') && validFileType && validFileSize && !invalidFileType) {
                    self.element.closest('form').dirtyForms('rescan');
                }
            });
        },
        _handleSubmit: function (event) {
            this.options.callback.call(this, { parentID: this.options.parentid, value: this.element.attr('multiple') ? this.element[0].files : this.element[0].files[0] }, event);
            if (this.options.autoupload) {
                this.reset();
            }
            return false;
        },
        _formatBytes: function (bytes, decimals) {
            if (decimals === undefined) {
                decimals = 2;
            }
            if (bytes === 0) {
                return '0 B';
            }

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        _showSelectionControls: function (name, fileItem) {
            fileItem.find('label').removeClass('text-danger').text(name);
            this.$removeButton.removeClass('d-none');
            if (this.options.uploadbutton && this.element[0].files.length) {
                this.$uploadButton.removeClass('d-none');
            }
            this.$buttonGroup.toggleClass('btn-group', this.$buttonGroup.children(':visible').length > 1);
            if (this.options.advancedupload) {
                this.$dropZoneTitle.addClass('d-none');
                if (!isMobile) {
                    this.$copyPasteTitle.addClass('d-none');
                }
            }
        },
        _setUploading: function (isUploading) {
            this.isUploading = isUploading;
            this.$buttonGroup.toggleClass('d-none', isUploading).toggleClass('d-flex', !isUploading);
            this.$container.toggleClass('disabled', isUploading);
            this.$uploadmessage.toggleClass('d-none', !isUploading);
        },
        startUpload: function () {
            this._setUploading(true);
            this._laddaInstance.start();
        },
        stopUpload: function () {
            this._setUploading(false);
            this._laddaInstance.stop();
        },
    });
}(jQuery));